import React from "react";
import UsersList from "./UsersList";
const Etape1 = ({
  renderError,
  formData,
  setFormData,
  handleChange,
  errorMessage,
  isReadOnly,
  page,
  rejectedRequest,
  isCheckingRejectedRequest,
  rejectedRequestLookupError,
}) => {

  // Function to handle user selection and trigger form change
  const handleUserSelect = (user, fieldName) => {
    console.log(user.employeeId)
    handleChange({
      target: {
        name: fieldName,
        value: {
          nom: user.displayName,
          email: user.mail,
          userId: user.id,
          matricule :user.employeeId,
          etatDemande:""
        },
      },
    });
  };
 
  const RadioQuestion = ({ name, label, value, onChange }) => (

    <div className="w-[85%] grid grid-cols-2 items-center gap-4">
  <label className="text-sm font-semibold text-gray-800 flex items-center">
    {label} <span className="text-red-500 ml-1">*</span>
  </label>

  <div className="flex items-center gap-3">
          {["oui", "non"].map((option) => {
            const isSelected = value === option;

            return (
              <label
                key={option}
                className={`
                  flex items-center justify-center w-[80px]
                  px-4 py-2 rounded-lg cursor-pointer
                  text-sm font-medium
                  border transition-all duration-200
                  focus-within:ring-2 focus-within:ring-blue-300 focus-within:ring-offset-1
                  ${
                    isSelected
                      ? "bg-blue-100 text-blue-600 border-blue-300"
                      : "bg-white text-gray-500 border-gray-300 hover:border-gray-400 hover:text-gray-600"
                  }
                `}
              >
                <input
                  type="radio"
                  name={name}
                  value={option}
                  checked={isSelected}
                  onChange={onChange}
                  className="sr-only"
                  disabled={isReadOnly}
                />
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </label>
            );
          })}
        </div>
</div>

  );
  
  
const RadioQuestionmembre = ({
    name,
    label,
    value,
    onChange,
  }) => {
    return (
      <div className={`flex flex-col gap-2 w-full`}>
        <label className="text-sm font-medium text-gray-900 ">
          {label} <span className="text-red-400 ml-1">*</span>
          
        </label>

        <div className="flex items-center gap-3">
          {["oui", "non"].map((option) => {
            const isSelected = value === option;

            return (
              <label
                key={option}
                className={`
                  flex items-center justify-center w-[80px]
                  px-4 py-2 rounded-lg cursor-pointer
                  text-sm font-medium
                  border transition-all duration-200
                  focus-within:ring-2 focus-within:ring-blue-300 focus-within:ring-offset-1
                  ${
                    isSelected
                      ? "bg-blue-100 text-blue-600 border-blue-300"
                      : "bg-white text-gray-500 border-gray-300 hover:border-gray-400 hover:text-gray-600"
                  }
                `}
              >
                <input
                  type="radio"
                  name={name}
                  value={option}
                  checked={isSelected}
                  onChange={onChange}
                  className="sr-only"
                  disabled={isReadOnly}
                />
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </label>
            );
          })}
        </div>
      </div>
    );
  };
  /************************************************************************/

  return (
    <div className=" p-4 ">
    
        {/* <h1 className="text-2xl font-bold mb-6 text-black">
          Information générale
        </h1> */}
        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
          </div>
          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="numeroFormulaire"
              className="block text-sm font-medium text-blue-900"
            >
              Numéro de formulaire:
            </label>
            <input
              type="text"
              id="numeroFormulaire"
              name="numeroFormulaire"
              value={formData.numeroFormulaire}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
          </div>
        </div>

        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
          </div>
          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Date :
            </label>
            <input
              type="date"
              id="dateSoumission"
              name="dateSoumission"
              value={formData.dateSoumission?.split("T")[0] ?? ""}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>
        </div>
        
        <div className="w-full flex justify-center mt-6 mb-20">
  <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
    <p className="text-md font-bold flex items-center gap-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
        />
      </svg>
      Réclamation mensuelle de dépenses d'emploi
    </p>
  </div>
</div>

        <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-blue-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.27.534 6.121 1.47M15 10a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
    Information du membre du personnel
  </p>
</div>


        <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="nom"
              className="block text-sm font-medium text-blue-900"
            >
              Nom:
            </label>
            <input
              type="text"
              id="nom"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              required
              readOnly
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
          </div>

          <div className="w-3/5">
        <RadioQuestionmembre
          name="soumisAutreMembre"
          label="Soumis de la part d'un autre membre du personnel"
          value={formData.soumisAutreMembre}
          onChange={handleChange}
        />
  {/* <label
    htmlFor="soumisAutreMembre"
    className="block text-sm font-semibold text-blue-900 mb-1"
  >
    Soumis de la part d'un autre membre du personnel <span className="text-red-500">*</span> :
  </label>

  <div className="mt-2 flex space-x-3">
    {["oui", "non"].map((option) => {
      const isSelected = formData.soumisAutreMembre === option;
      return (
        <label
          key={option}
          className={`cursor-pointer px-3 py-1 text-sm rounded-md border transition-colors duration-150
            ${isSelected ? "bg-blue-600 text-white border-blue-600" : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"}`}
        >
          <input
            type="radio"
            name="soumisAutreMembre"
            value={option}
            onChange={handleChange}
            className="hidden"
            disabled={isReadOnly}
          />
          {option.charAt(0).toUpperCase() + option.slice(1)}
        </label>
      );
    })}
  </div> */}

  {renderError("soumisAutreMembre")}
</div>

        </div>

        {formData.soumisAutreMembre === "oui" && (
        <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Soumis de la part de <span className="text-xl text-red-900" >*</span> :
            </label>
            <div className="relative">
              {/* Add the UsersList component with the callback for user selection */}
              {isReadOnly===false && !formData?.soumisParAutreMembre?.nom && (
                <UsersList onUserSelect={(user) => handleUserSelect(user, "soumisParAutreMembre")} initialValue={formData.soumisParAutreMembre.email}/>
              )}

                {/* Display the selected user's information */}
                {formData?.soumisParAutreMembre?.nom && (
                  <div className="p-3 rounded-2xl border border-gray-200 shadow-sm bg-white flex items-center gap-4">
                    {/* Avatar */}
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 font-semibold text-lg">
                      {formData.soumisParAutreMembre.nom.charAt(0).toUpperCase()}
                    </div>

                    {/* Infos */}
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-gray-900">
                        {formData.soumisParAutreMembre.nom}
                      </span>
                      <span className="text-sm text-gray-700">
                        {formData.soumisParAutreMembre.email}
                      </span>
                    </div>

                    {/* Bouton supprimer */}
                    {!isReadOnly && (
                      <button
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            soumisParAutreMembre: {
                            },
                          }))
                        }
                        className="ml-auto text-red-400 hover:text-red-500 transition"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                )}
            </div>
            {renderError("soumisParAutreMembre")}
          </div>
          <div className="w-3/5">
          <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Raison de soumission <span className="text-xl text-red-900" >*</span> :
            </label>
            <textarea
              placeholder="Ajoutez un commentaire..."
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              rows="2"
              id="commentaireRaisonSoumission"
              name="commentaireRaisonSoumission"
              value={formData.commentaireRaisonSoumission}
              onChange={handleChange}
              readOnly={isReadOnly}
            ></textarea>
            {renderError("commentaireRaisonSoumission")}
          </div>
        </div>
        )}


        <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Poste occupé <span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="posteOccupe"
              name="posteOccupe"
              value={formData.posteOccupe}
              onChange={handleChange}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              readOnly={isReadOnly}
            />
             {renderError("posteOccupe")} 
          </div>
          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              École ou Service <span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="LieuTravail"
              name="LieuTravail"
              value={formData.LieuTravail}
              onChange={handleChange}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              readOnly={isReadOnly}
            />
            {renderError("LieuTravail")}
          </div>
        </div>


        <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-3/5">
            <label
              htmlFor="fileUpload"
              className="block text-sm font-medium text-blue-900 "
            >
              Superviseur <span className="text-xl text-red-900" >*</span> :
            </label>
            <div className="relative">
              {/* Add the UsersList component with the callback for user selection */}
              {isReadOnly===false &&!formData?.managerInfo?.nom && (
                <UsersList onUserSelect={(user) => handleUserSelect(user, "managerInfo")} initialValue={formData.managerInfo.email}/> 
                )}

                {/* Display the selected user's information */}
                {formData?.managerInfo?.nom && (
                  <div className=" p-3 rounded-2xl border border-gray-200 shadow-sm bg-white flex items-center gap-4">
                    {/* Avatar */}
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 font-semibold text-lg">
                      {formData.managerInfo.nom.charAt(0).toUpperCase()}
                    </div>

                    {/* Infos */}
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-gray-900">
                        {formData.managerInfo.nom}
                      </span>
                      <span className="text-sm text-gray-700">
                        {formData.managerInfo.email}
                      </span>
                    </div>

                    {/* Bouton supprimer */}
                    {!isReadOnly && (
                      <button
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            managerInfo: {
                              nom: "",
                              email: "",
                              userId: "",
                              matricule: "",
                              etatDemande: "",
                            },
                          }))
                        }
                        className="ml-auto text-red-400 hover:text-red-500 transition"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                )}
            </div>
            {renderError("managerInfo")}
          </div>
          <div className="w-3/5">
          <RadioQuestionmembre
          name="verificationDelegue"
          label="Vérification effectuée par un(e) délégué(e)"
          value={formData.verificationDelegue}
          onChange={handleChange}
        />
  {/* <label
    htmlFor="verificationDelegue"
    className="block text-sm font-semibold text-blue-900 mb-1"
  >
    Vérification effectuée par un(e) délégué(e) <span className="text-red-500">*</span> :
  </label>

  <div className="mt-2 flex space-x-3">
    {["oui", "non"].map((option) => {
      const isSelected = formData.verificationDelegue === option;
      return (
        <label
          key={option}
          className={`cursor-pointer px-3 py-1 text-sm rounded-md border transition-colors duration-150
            ${isSelected ? "bg-blue-600 text-white border-blue-600" : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"}`}
        >
          <input
            type="radio"
            name="verificationDelegue"
            value={option}
            onChange={handleChange}
            className="hidden"
            disabled={isReadOnly}
          />
          {option.charAt(0).toUpperCase() + option.slice(1)}
        </label>
      );
    })}
  </div> */}
</div>

        </div>

        {formData.verificationDelegue === "oui" && (
        <div className="mt-5 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-3/5">
              <label
                htmlFor="fileUpload"
                className="block text-sm font-medium text-blue-900 "
              >
              Délégué(e) <span className="text-xl text-red-900" >*</span>:
              </label>
              <div className="relative">
                {/* Add the UsersList component with the callback for user selection */}
                {isReadOnly===false && !formData?.delegueInfo?.nom && (
                   <UsersList onUserSelect={(user) => handleUserSelect(user, "delegueInfo")} initialValue={formData.delegueInfo.email}/>
                )}

                  {/* Display the selected user's information */}
                  {formData?.delegueInfo?.nom && (
                  <div className="p-3 rounded-2xl border border-gray-200 shadow-sm bg-white flex items-center gap-4">
                    {/* Avatar */}
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 font-semibold text-lg">
                      {formData.delegueInfo.nom.charAt(0).toUpperCase()}
                    </div>

                    {/* Infos */}
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-gray-900">
                        {formData.delegueInfo.nom}
                      </span>
                      <span className="text-sm text-gray-700">
                        {formData.delegueInfo.email}
                      </span>
                    </div>

                    {/* Bouton supprimer */}
                    {!isReadOnly && (
                      <button
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            delegueInfo: {
                              nom: "",
                              email: "",
                              userId: "",
                              matricule: "",
                              ecole: "",
                              etatDemande: "",
                            },
                          }))
                        }
                        className="ml-auto text-red-400 hover:text-red-500 transition"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                )}
              </div>
              {renderError("delegueInfo")}
            </div>
        </div>)}
      
        <div className="mt-[6%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-yellow-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    Période de réclamation
  </p>
</div>


        <div className="mt-5 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-1/2 ">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Mois <span className="text-xl text-red-900" >*</span> :
            </label>
              {(() => {
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, "0");

                // mois courant (max)
                const maxMonth = `${year}-${month}`;

                // mois -12 (min)
                const past = new Date(now.setMonth(now.getMonth() - 12));
                const minYear = past.getFullYear();
                const minMonth = String(past.getMonth() + 1).padStart(2, "0");
                const minMonthValue = `${minYear}-${minMonth}`;

                return (
                  <input
                    type="month"
                    id="periodReclamation"
                    name="periodReclamation"
                    value={formData.periodReclamation}
                    onChange={handleChange}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                    readOnly={isReadOnly}
                    min={minMonthValue}
                    max={maxMonth}
                    // onKeyDown={(e) => e.preventDefault()} // ⛔ bloque la saisie clavier
                  />
                );
              })()}
            {renderError("periodReclamation")}
            {isCheckingRejectedRequest && (
              <p className="mt-2 text-xs text-slate-500">
                Vérification des demandes rejetées...
              </p>
            )}
            {rejectedRequest && (
              <div
                className="mt-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm"
                role="status"
              >
                <div className="flex items-start gap-3">
                  <svg
                    className="mt-0.5 h-5 w-5 flex-none text-amber-600"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8.485 2.495a1.75 1.75 0 0 1 3.03 0l6.28 10.86A1.75 1.75 0 0 1 16.28 16H3.72a1.75 1.75 0 0 1-1.515-2.645l6.28-10.86ZM10 6.75a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 10 6.75Zm0 6a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <div>
                    <p className="font-semibold text-amber-900">
                      Une demande rejetée existe déjà pour cette période.
                    </p>
                    <p className="mt-1 text-xs font-medium text-amber-800">
                      Numéro de la demande :{" "}
                      <span className="font-mono font-semibold">
                        {rejectedRequest.numeroFormulaire}
                      </span>
                    </p>
                    <p className="mt-1 leading-5 text-amber-800">
                      Corrigez et soumettez de nouveau cette demande plutôt que de créer une nouvelle demande.
                    </p>
                    <a
                      href={`/formulaire?numeroFormulaire=${encodeURIComponent(
                        rejectedRequest.numeroFormulaire,
                      )}&page=Mes%20demandes`}
                      className="mt-2 inline-flex font-semibold text-amber-900 underline decoration-amber-400 underline-offset-2 hover:text-amber-700"
                    >
                      Corriger la demande rejetée →
                    </a>
                  </div>
                </div>
              </div>
            )}
            {rejectedRequestLookupError && (
              <p className="mt-2 text-xs text-red-600">
                {rejectedRequestLookupError}
              </p>
            )}
            {/* {errorMessage && (
              <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
            )} */}
            {(errorMessage || formData.periodDepasseTroisMois==="oui") && (
              <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
            )}
          </div>
          {(errorMessage || formData.periodDepasseTroisMois==="oui") && (
              <div className="w-3/5">
              <label
                  htmlFor="dateEntreeEnVigueur"
                  className="block text-sm font-medium text-blue-900"
                >
                  Justification du dépassement du délai <span className="text-xl text-red-900" >*</span> :
                </label>
                <textarea
                  placeholder="Ajoutez une justification..."
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                  rows="2"
                  id="justificationOutrepasse"
                  name="justificationOutrepasse"
                  value={formData.justificationOutrepasse}
                  onChange={handleChange}
                  readOnly={isReadOnly}
                ></textarea>
                {renderError("justificationOutrepasse")}
              </div>
          )}
        </div>

        <div className="mt-[4%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-green-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 10h.01M12 10h.01M16 10h.01M9 16h6M21 12c0 4.418-4.03 8-9 8s-9-3.582-9-8 4.03-8 9-8 9 3.582 9 8z"
      />
    </svg>
    Questions
  </p>
</div>



      <div className="mt-10 grid gap-0">
        <RadioQuestion
          name="achatsCarteCréditProfessionnelle"
          label="Avez-vous effectué des achats avec votre carte de crédit professionnelle Visa du Conseil?"
          value={formData.achatsCarteCréditProfessionnelle}
          onChange={handleChange}
        />
        </div>

        <div className="mt-10 grid gap-0">
        <RadioQuestion
          name="depensesEtrReclamer"
          label="Avez-vous des dépenses de 407 ETR à réclamer?"
          value={formData.depensesEtrReclamer}
          onChange={handleChange}
        />
      </div>

      <div className="mt-10 grid gap-0">
        <RadioQuestion
          name="depensesActiviteExterne"
          label="Avez-vous effectué des dépenses reliées à une formation, colloque ou activité externe?"
          value={formData.depensesActiviteExterne}
          onChange={handleChange}
        />
        </div>
        <div className="mt-10 grid gap-0">
        <RadioQuestion
          name="reclameBoissonAlcoolise"
          label="Avez-vous réclamé de la boisson alcoolisée?"
          value={formData.reclameBoissonAlcoolise}
          onChange={handleChange}
        />
        {/* {formData.reclameBoissonAlcoolise==="oui" && (
          <p className="text-red-500 text-sm mt-2">Aucune boisson alcoolisée ne peut être réclamée.</p>
        )} */}
        {renderError("reclameBoissonAlcoolise")}
      </div>

    </div>
  );
};

export default Etape1;
